import React from 'react'
import CartBuy from '../Components/Cart/CartBuy'
import Footer from '../Components/Footer/Footer'
import Navbar from '../Components/NavBar/NavBar'
import TabComponent from '../Components/Tabs/Tabs'

const Cart = () => {
  return (
    <div>
        <Navbar/>
        <TabComponent/>
        <Footer/>
    </div>
  )
}

export default Cart
